import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

/**
 * Hook to automatically calculate monthly salary based on salary grade and step
 * @param {Object} employeeData - Current employee data
 * @param {Function} updateKVSField - Function to update KVS field
 */
export const useSalaryCalculation = (employeeData, updateKVSField) => {
  const { biz_kvs = {} } = useSelector(state => state.bizMeta);

  // Use useRef to track previous values and prevent infinite loops
  const prevSalaryGrade = React.useRef(null);
  const prevSalaryStep = React.useRef(null);

  // Calculate salary when salary grade or step changes
  const calculateSalary = React.useCallback(() => {
    // Find the PR object in KVS array
    const prKvs = employeeData?.kvs?.find(item => item.key === 'pr');
    const prData = prKvs?.value || {};
    
    const salaryGrade = prData?.salary_grade;
    const salaryStep = prData?.salary_step;
    
    
    // Only calculate if both grade and step are provided AND they actually changed
    if (salaryGrade && salaryStep && 
        (salaryGrade !== prevSalaryGrade.current || salaryStep !== prevSalaryStep.current)) {
      
      
      // Find salary grade map entries in biz_kvs array
      const salaryGradeMapEntries = biz_kvs?.filter(item => item.key === 'salary_grade_map') || [];
      
      if (salaryGradeMapEntries.length > 0) {
        try {
          // Find the salary entry from the salary grade map
          const salaryEntry = salaryGradeMapEntries.find(
            item => item.id1 === parseInt(salaryGrade) && item.id2 === parseInt(salaryStep)
          );
          
          
          if (salaryEntry && salaryEntry.value) {
            
            // Update the monthly salary field using the correct field path
            updateKVSField({
              target: {
                name: 'pr',
                value: {
                  ...prData,
                  monthlySalary: salaryEntry.value
                }
              }
            });
            
            // Update refs after successful update
            prevSalaryGrade.current = salaryGrade;
            prevSalaryStep.current = salaryStep;
          }
        } catch (error) {
        }
      }
    } else {
    }
  }, [employeeData?.kvs, biz_kvs, updateKVSField]);

  // Watch for changes in salary grade or step
  useEffect(() => {
    const prKvs = employeeData?.kvs?.find(item => item.key === 'pr');
    const prData = prKvs?.value || {};
    
    const salaryGrade = prData?.salary_grade;
    const salaryStep = prData?.salary_step;
    
    // If both values are present, calculate salary
    if (salaryGrade && salaryStep) {
      calculateSalary();
    }
  }, [employeeData?.kvs]);
};

export default useSalaryCalculation; 